import { css } from 'styled-components';

export const droppedCard = css`
  position: relative;
  & > img {
    opacity: 0.5;
  }
  &:after {
    position: absolute;
    content: '';
    inset: 0;
    border-radius: 5%;
    outline: 1px solid var(--c-rewards-orange);
    background: radial-gradient(
      154.46% 96.82% at 50% 3.18%,
      rgba(255, 78, 34, 0) 70%,
      var(--c-rewards-orange) 100%
    );
  }
`;
